import React, { FC } from 'react';

import { useMobile } from 'Modules/ui3';

import { PageContainer } from '../../components/PageContainer';
import { SectionTitleH1 } from '../../components/Titles';
import { RegistrationDocuments } from '../../components/RegistrationDocuments';


export const Registration: FC = () => {
    const isMobile = useMobile();

    return (
        <PageContainer withMainButton>
            {!isMobile && (
                <SectionTitleH1 mt={0} mb={8}>
                    Документы для регистрации
                </SectionTitleH1>
            )}
            <RegistrationDocuments />
        </PageContainer>
    );
};
